import { combineReducers } from 'redux';
import { AuthConstants, authReducer, forgotPasswordReducer } from './auth';

import { passwordReducer, profileReducer } from './user';

import { buildingReducer } from './building';
import { utilityReducer } from './utility';
import { diagnosticsReducer } from './diagnostics';
import { thermostatReducer } from './thermostat';
import { networkReducer } from './network';
import { suiteReducer } from './suite';
import { alertsReducer } from './alerts';
import { buildingUserReducer } from './buildinguser';

const appReducer = combineReducers({
  authReducer,
  buildingReducer,
  forgotPasswordReducer,
  passwordReducer,
  profileReducer,
  thermostatReducer,
  utilityReducer,
  diagnosticsReducer,
  networkReducer,
  suiteReducer,
  alertsReducer,
  buildingUserReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === AuthConstants.Logout) {
    state = undefined;
  }

  return appReducer(state, action);
};

export { AuthActions, authInitialState, AuthConstants, ForgotPasswordConstants } from './auth';
export { BuildingActions, BuildingConstants, buildingReducerInitialState } from './building';
export { DiagnosticsActions, DiagnosticsConstants, diagnosticsReducerInitialState } from './diagnostics';
export { NetworkActions, NetworkConstants } from './network';
export { SuiteActions, SuiteConstants, suiteReducerInitialState } from './suite';
export { ThermostatActions, ThermostatConstants, thermostatReducerInitialState } from './thermostat';
export { UserActions, ProfileConstants, PasswordConstants } from './user';
export { UtilityActions, UtilityConstants, utilityReducerInitialState } from './utility';
export { AlertsActions, AlertsConstants, alertsReducerInitialState } from './alerts';
export { BuildingUserActions, BuildingUserConstants, buildingUserReducerInitialState } from './buildinguser';
